import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import CorpListUpdateInfoPopup from './corp-list-update-Info-popup';
import CorpListStore from './corp-list-store';

const CorpListUpdateInfoPopupContainer = () => {
  const {
    updateUserInfoList,
    updateUserLimitInfoList,
    visibleUpdateInfoPopup,
  } = CorpListStore;

  const tabs = [{ text: '사용자 변경내역' }, { text: '이용한도 변경내역' }];

  const [updateInfo, setUpdateInfo] = useState({
    selectedIndex: 0,
  });

  useEffect(() => {
    // console.log('CorpListUpdateInfoPopupContainer > useEffect()');

    return () => {
      setUpdateInfo({ selectedIndex: 0 });
    };
  }, [updateUserInfoList, updateUserLimitInfoList, visibleUpdateInfoPopup]);

  const onItemClick = useCallback(
    (event) => {
      setUpdateInfo({ ...updateInfo, selectedIndex: event.itemIndex });
    },
    [updateInfo]
  );

  if (!updateUserInfoList || !updateUserLimitInfoList) {
    return;
  }

  return (
    <CorpListUpdateInfoPopup
      onHiding={() => CorpListStore.setVisibleUpdateInfoPopup(false)}
      onItemClick={onItemClick}
      updateInfo={updateInfo}
      updateUserInfoList={updateUserInfoList}
      updateUserLimitInfoList={updateUserLimitInfoList}
      visibleUpdateInfoPopup={visibleUpdateInfoPopup}
      tabs={tabs}
    />
  );
};

export default React.memo(observer(CorpListUpdateInfoPopupContainer));
